import { Navigate, Outlet } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'

// Guards routes like /login: an already-authenticated user shouldn't be able to revisit
// them, so this redirects straight to the dashboard instead of showing the login form again.
export const PublicOnlyRoute = () => {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="flex h-screen w-screen items-center justify-center bg-bg transition-colors duration-300">
        <div className="flex flex-col items-center gap-4">
          <div className="relative flex h-16 w-16 items-center justify-center">
            <div className="absolute h-full w-full animate-ping rounded-full bg-primary opacity-20"></div>
            <div className="h-12 w-12 animate-spin rounded-full border-4 border-primary border-t-transparent"></div>
          </div>
          <span className="text-sm font-semibold tracking-wider text-text-secondary animate-pulse">
            Verifying session...
          </span>
        </div>
      </div>
    )
  }

  if (user) {
    return <Navigate to="/dashboard" replace />
  }

  return <Outlet />
}
